export default __webpack_public_path__ + "static/shop-new-arrivals-55b1affc1947fafd23f725ce26679cf4.webp";